import Reports from './Reports';

export default { Reports };
export { Reports };
